
import Storage from "@/utils/storage.js"
import api from "@/request/api"
import router from '@/router'
import { Post,Get,Put } from "@/request/index.js"
const state = {
  baseUrl:process.env.VUE_APP_BASE_API_URL+"/23s3-dgmedia-zkt-backend/sys/common/static/",
  currentYear:Storage.getItem("currentYear"),  //当前年份
}
const mutations = {
  //设置当前年份
  setCurrentYear(state,year){
    state.currentYear = year
    Storage.setItem("currentYear", year)
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



